export class Station {
  constructor(id, name) {
    this.id = id;
    this.name = name;
  }

  // set stations from response array
  static setStations(stations) {
    return stations.map((station) => new Station(station.id, station.name));
  }

  static setStation(station) {
    return new Station(station?.id, station?.name);
  }
}
